const Group = () => {
  return (
    // Mobile: vertical stacked, desktop: original horizontal with vectors
    <div
      className="w-full bg-[#051d62] text-white py-10 text-center 
                md:flex md:justify-between md:items-center 
                md:bg-transparent  md:py-0 "
    >
      {/* Mobile Layout */}
      <div className="space-y-10 md:hidden">
        <div>
          <p className="text-3xl font-semibold">99.5%</p>
          <p className="opacity-90 mt-1">Visas approved</p>
        </div>
        <div>
          <p className="text-3xl font-semibold">10000+</p>
          <p className="opacity-90 mt-1">Students Guided</p>
        </div>
        <div>
          <p className="text-3xl font-semibold">100%</p>
          <p className="opacity-90 mt-1">Student satisfaction</p>
        </div>
        <div>
          <p className="text-3xl font-semibold">2024</p>
          <p className="opacity-90 mt-1">Established</p>
        </div>
      </div>

      {/* Desktop Layout */}
      <div className="service-desktop-layout hidden md:flex md:w-full md:items-center md:justify-between md:gap-8 bg-[#051d62]">
        <div className="flex flex-col items-center text-center">
          <div className="text-3xl font-semibold">99.5%</div>
          <div className="opacity-80">Visas approved</div>
        </div>

        <img
          className="h-10"
          alt="Separator"
          src="https://c.animaapp.com/HwA6Ml4A/img/vector-24.svg"
        />

        <div className="flex flex-col items-center text-center">
          <div className="text-3xl font-semibold">10000+</div>
          <div className="opacity-80">Students Guided</div>
        </div>

        <img
          className="h-10"
          alt="Separator"
          src="https://c.animaapp.com/HwA6Ml4A/img/vector-25.svg"
        />

        <div className="flex flex-col items-center">
          <div className="text-3xl font-semibold">100%</div>
          <div className="opacity-80">Student satisfaction</div>
        </div>

        <img
          className="h-10"
          alt="Separator"
          src="https://c.animaapp.com/HwA6Ml4A/img/vector-26.svg"
        />

        <div className="flex flex-col items-center">
          <div className="text-3xl font-semibold">2024</div>
          <div className="opacity-80">Established</div>
        </div>
      </div>
    </div>
  );
};
export default Group;